"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorldpayTransaction = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const getWorldpayTransaction = (originalPayment, refundTransaction) => {
    return originalPayment.transactions.find((transaction) => transaction.paymentTypeId === homi_shared_1.PaymentTypeIds.worldpay &&
        transaction.terminalInvoiceId === refundTransaction.refundTerminalInvoiceId);
};
exports.getWorldpayTransaction = getWorldpayTransaction;
//# sourceMappingURL=getWorldpayTransaction.js.map